enum TokenConstants {
  NAME = 'name',
  NR_SEQ_USER = 'ext_nrSeqUser',
}

export default TokenConstants;
